import Api from "./Api";
import Api_2 from "./Api_extra";
import { createQueryString } from "./ApiHelper";
import axios from "axios";
import { BASEURL } from "@/config/index";
export default {
  GetActiveCinemas(payload) {
    return Api().post("/active-list/ms_cinemas", payload);
  },
  GetValidCinemas(payload) {
    let cine_id =
      payload.cine_id && payload.cine_id.toString().length > 0
        ? payload.cine_id
        : "";
    return Api().get(`/active-list/get-valid-cinemas?cine_id=${cine_id}`);
  },
  GetValidCinemasLoyalty(payload) {
    return Api().get(
      "/active-list/get-valid-cinemas-loyalty?c_id=" + payload.cine_id
    );
  },
  GetInActiveCinemas(payload) {
    return Api().post("/get_ms_cinemas", payload);
  },
  GetActiveCinemasChargeType(payload) {
    return Api().post("/active-list/ms_charge_types", payload);
  },
  GetActiveScreenByCinema(payload) {
    if (
      payload &&
      payload.hasOwnProperty("searchValue") &&
      payload.hasOwnProperty("columnName")
    ) {
      return Api().post(
        `/active-list/screens?searchValue=${payload.searchValue}&searchKey=${payload.searchKey}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`,
        payload
      );
    } else {
      return Api().post("/active-list/screens", payload);
    }
  },
  GetScreenSeatlayoutIds() {
    return Api().get("/getseatlayout");
  },
  GetRatecardsList(payload) {
    return Api().get(
      `/api/admin/ms_rate_cards/${payload.cinema_id}?searchKey=` +
        payload.searchKey +
        "&searchValue=" +
        payload.searchValue +
        "&limit=" +
        payload.limit +
        "&currentPage=" +
        payload.currentPage +
        "&columnName=" +
        payload.columnName +
        "&orderBy=" +
        payload.orderBy +
        "&filter_is_active=" +
        payload.filter_is_active
    );
  },
  GetRatecardById(payload) {
    return Api().get(`/api/admin/ms_rate_cards?rc_id=${payload.rc_id}`);
  },
  // /api/admin/count_of_seats
  GetCountOfScreen(payload) {
    return Api().post(`/api/admin/count_of_seats`, payload);
  },
  AddRatecard(payload) {
    return Api().post(`/api/admin/ms_rate_cards`, payload);
  },
  UpdateRatecard(payload) {
    return Api().put(`/api/admin/ms_rate_cards/${payload.id}`, payload);
  },
  GetActiveRatecardByCinemaAndCurrencyId(payload) {
    return Api().get(
      `/api/admin/getratecards/${payload.cinema_id}/${payload.currency_id}`
    );
  },

  //Rate card group

  AddRateCardGroup(payload) {
    return Api().post(`/api/admin/rate_card_group`, payload);
  },
  GetRateCardGroup(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/admin/rate_card_group${qs}`);
    // if (
    //   payload &&
    //   payload.hasOwnProperty("limit") &&
    //   payload.hasOwnProperty("currentPage") &&
    //   payload.hasOwnProperty("columnName") &&
    //   payload.hasOwnProperty("orderBy")
    // ) {
    //   return Api().get(
    //     `/api/admin/rate_card_group?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&searchValue=${payload.searchValue}&filter_is_active=${payload.filter_is_active}`
    //   );
    // }
    // return Api().get(`/api/admin/rate_card_group`);
  },
  EditRateCardGroup(payload) {
    return Api().put(`/api/admin/rate_card_group/${payload.id}`, payload);
  },
  GetRateGroupCardById(payload) {
    console.log("payload at cinemaservi", payload);
    return Api().get(`/api/admin/rate_card_group?id=${payload.rc_g_id}`);
  },

  // Backup
  GetAllBackupSetting(payload) {
    return Api().get(
      `/api/admin/backupsetting?limit=${payload.limit}&currentPage=${payload.currentPage}`
    );
  },

  ReadABackupSetting(payload) {
    return Api().post(`/api/admin/backupsetting`, payload);
  },

  UpdateABackupSetting(payload) {
    return Api().put(`/api/admin/backupsetting`, payload);
  },

  // Add Cinema Charges
  GetCinemaChargesByCinemaId(payload) {
    return Api().post(
      `/api/admin/cinemachargesbycinemaid/${payload.id}`,
      payload
    );
    // return Api().get(`/ms_price_addition_settings/${payload.id}`);
  },

  GetCinemaChargesListByCinemaId(payload, body) {
    return Api().post(
      `/api/admin/cinemachargesbycinemaid/${payload}?searchKey=${body.searchKey}&searchValue=${body.searchValue}&limit=${body.limit}&currentPage=${body.currentPage}&filter_is_active=${body.filter_is_active}`,
      payload
    );
    // return Api().get(`/ms_price_addition_settings/${payload.id}`);
  },
  // GetCinemaChargesByCinemaId(payload, body) {
  //   let url = `/api/admin/cinemachargesbycinemaid/${payload}`;
  //   console.log('body :', body);
  //   if (body && body.hasOwnProperty('limit') && body.hasOwnProperty('currentPage')) {
  //     url += `?limit=${body.limit}&currentPage=${body.currentPage}`
  //   };
  //   return Api().post(url, payload);
  //   // return Api().get(`/ms_price_addition_settings/${payload.id}`);
  // },
  GetCinemaSettingNameByCinemaId(payload) {
    return Api().get(`/api/admin/cinemasettingsnamebycinemaid/${payload.id}`);
  },
  GetChargeSettingsWithChargeTypes(payload) {
    return Api().get(
      `/api/admin/charge_settings_with_charges/${payload.cinema_id}`
    );
  },
  AddCinemaCharges(payload) {
    return Api().post(`/api/admin/cinemacharges`, payload);
  },
  GetCinemaCharges() {
    return Api().get(`/api/admin/cinemacharges`);
  },
  UpdateCinemaCharges(payload) {
    return Api().put(
      `/api/admin/cinemachargesbycinemaid/${payload.cinema_id}`,
      payload
    );
  },
  GetCinemaChargesById(payload) {
    return Api().post(`/api/admin/viewcinemacharges`, payload);
  },
  // TicketPriceConfigurationList
  GetTicketPriceConfiguration: function(payload) {
    // movie_id=${payload.movie_id}&cine_id=${payload.cine_id}
    let query = "";
    let length = Object.keys(payload).length;
    if (length > 0) {
      query = "?";
      Object.keys(payload).map((x, index) => {
        if (payload[x]) {
          query +=
            index === length - 1 ? `${x}=${payload[x]}` : `${x}=${payload[x]}&`;
        }
      });
    }
    return Api().get(`/api/admin/ticketpriceconfiguration${query}`);
  },
  addTicketPriceConfiguration: function(payload) {
    return Api().post(`/api/admin/ticketpriceconfiguration`, payload);
  },
  GetTicketPriceConfigurationById: function(payload) {
    return Api().get(
      `/api/admin/ticketpriceconfiguration/${payload.md_id}/${payload.ss_id}`
    );
  },
  UpdatedPriceConfigurationById: function(payload) {
    return Api().put(`/api/admin/ticketpriceconfiguration`, payload);
  },
  /**
   * Float Amount
   */
  AddFloatAmount(payload) {
    return Api().post(`/api/admin/cinemafloatamount`, payload);
  },
  GetFloatAmount(payload) {
    let cinema_id =
      payload.cinema_id && payload.cinema_id.toString().length > 0
        ? payload.cinema_id
        : "";
    let qs = createQueryString(payload);

    return Api().get(`/api/admin/cinemafloatamount?${qs}`);
  },
  GetFloatAmountById(payload) {
    return Api().get(`/api/admin/cinemafloatamount/${payload.float_id}`);
  },
  UpdateFloatAmount(payload) {
    return Api().put(
      `/api/admin/cinemafloatamount/${payload.float_id}`,
      payload
    );
  },
  /**
   * Float Amount End
   */
  /**
   * Hardware Setting
   */
  AddHardwareSettigns(payload) {
    return Api().post(`/api/admin/hardwaresetting`, payload);
  },
  GetHardwareSettigns(payload) {
    return Api().get(
      `/api/admin/hardwaresetting?limit=${payload.limit}&currentPage=${payload.currentPage}&searchValue=${payload.searchValue}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&status=${payload.status}&cinema_id=${payload.cinema_id}`
    );
  },
  GetHardwareSettignsById(payload) {
    return Api().get(`/api/admin/hardwaresetting/${payload.hs_id}`);
  },
  GetHardwareDevicesStatus(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/admin/hardwaredevicesstats/${qs}`);
  },
  UpdateHardwareSettigns(payload) {
    return Api().put(`/api/admin/hardwaresetting/${payload.hs_id}`, payload);
  },
  ArchiveHarrdwareDevice(payload) {
    return Api().put(`/api/admin/archiveHardware/${payload}`);
  },
  /**
   * Hardware Setting End
   */

  /* Shift Close  */
  GetShiftClose(payload) {
    let cinema_id =
      payload.cinema_id && payload.cinema_id.toString().length > 0
        ? payload.cinema_id
        : "";
    return Api().get(
      `/api/admin/closeshift?limit=${payload.limit}&currentPage=${payload.currentPage}&start_date=${payload.startDate}&end_date=${payload.endDate}&shift_status=${payload.shiftStatus}&searchValue=${payload.searchValue}&cinema_id=${cinema_id}&isPdf=${payload.isPdf}&isExcel=${payload.isExcel}&cinema_address=${payload.cinema_address}&cinema_name=${payload.cinema_name}&user_id=${payload.user_id}`
    );
  },
  UpdateShiftClose(payload) {
    return Api().put(`/api/admin/closeshift`, payload);
  },
  /* Shift Close End  */

  AddConcession(payload) {
    return Api().post("/api/admin/concession", payload);
  },
  listConcession(payload, cinema_id) {
    return Api().post(
      `/api/admin/getconcession?limit=${payload.limit}&currentPage=${payload.currentPage}`,
      cinema_id
    );
  },
  getConcessions(payload, cinema_id) {
    return Api().post(
      `/api/admin/getconcessionbyclid?limit=${payload.limit}&currentPage=${payload.currentPage}`,
      cinema_id
    );
  },
  updateConcession(payload) {
    return Api().put("/api/admin/concession", payload);
  },
  getTimeZoneList() {
    return Api().get("/api/admin/gettimezones");
  },

  listplannedschedule(payload) {
    return Api().post(
      `/api/admin/getplannedschedule?limit=${payload.limit}&currentPage=${payload.currentPage}`,
      payload
    );
  },
  updateplannedschedule(payload) {
    return Api().put(`/api/admin/getplannedschedule`, payload);
  },
  deletePlannedSchedule(payload) {
    return Api().post(`/api/admin/deleteplannedschedule`, payload);
  },

  //Support Ticket
  AddSupportTicket(payload) {
    return Api().post(`/api/admin/supportticket`, payload);
  },
  GetTickets(payload) {
    if (
      payload &&
      payload.hasOwnProperty("limit") &&
      payload.hasOwnProperty("currentPage") &&
      payload.hasOwnProperty("columnName") &&
      payload.hasOwnProperty("orderBy")
    ) {
      return Api().get(
        `/api/admin/supportticket?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`
      );
    } else if (
      payload &&
      payload.hasOwnProperty("limit") &&
      payload.hasOwnProperty("currentPage")
    ) {
      return Api().get(
        `/api/admin/supportticket?limit=${payload.limit}&currentPage=${payload.currentPage}`
      );
    } else {
      return Api().get(`/api/admin/supportticket?st_id=${payload.st_id}`);
    }
  },
  RespondSupportTicket(payload) {
    return Api().put(`/api/admin/supportticket`, payload);
  },
  RespondMycinemaSupportTicket(payload) {
    return Api().put(`/api/mycinema-support-ticket`, payload);
  },

  //insert custom field values
  InsertCustomFieldValues(payload) {
    return Api().post(`/api/admin/insertcustomfieldvalues`, payload);
  },
  UpdateCustomFieldValues(payload) {
    return Api().post(`/api/admin/updatecustomfieldvalues`, payload);
  },

  //Get FnB and Schedule Audit Logs
  GetAuditLogs(payload) {
    return Api().post(
      `/api/admin/getAuditlogs?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&searchValue=${payload.searchValue}`,
      payload
    );
  },
  DuplicateChargeSettings(payload) {
    return Api().post(`/api/admin/duplicatechargesettings`, payload);
  },
  GetMovieDetailList(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/pos/movie-detail-list${qs}`);
  },
  PingDevices() {
    return Api().get(`/api/device-hardware-settings/ping-devices`);
  },
  AddPrivateRatecard(payload) {
    return Api().post(`/api/admin/private_rate_card`, payload);
  },
  GetSinglePrivateRatecard(payload) {
    return Api().get(`/api/admin/get-private-rate-card/${payload.rcg_id}`);
  },
  GenerateManualBill(payload) {
    return Api().post(`/api/admin/manual_bill/generate_bill`, payload);
  },
  GetManualBillDetails(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/admin/manual_bill/getBill/${payload.bill_id}${qs}`);
  },
  GetManualBillTransactions(payload) {
    return Api().post(
      `/api/admin/manual_bill/manual_bill_transactions`,
      payload
    );
  },
  RefundManualBill(payload) {
    return Api().post(`/api/admin/manual_bill/manual_bill_refund`, payload);
  },
  GetScreenById(payload) {
    return Api().post(`/active-list/screens`, payload);
  },
  GetValidInvoiceNumbers(payload) {
    return Api().post(`/api/admin/credit_note/get_valid_invoices`, payload);
  },
  GetInvoiceDetailsByID(payload) {
    return Api().post(`/api/admin/credit_note/get_invoice_details`, payload);
  },
  GenerateCreditNote(payload) {
    return Api().post(`/api/admin/credit_note/generate_credit_note`, payload);
  },
  GetCreditNoteDetails(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/admin/credit_note/get_credit_note/${payload.creditNoteId}${qs}`);
  },
  GetCreditNotes(payload) {
    return Api().post(
      `/api/admin/credit_note/credit_notes`,
      payload
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/CinemasService.js